import React, { FunctionComponent } from 'react';
import { object, string } from 'yup';
import { FormikHelpers, Formik, FormikProps, Field } from 'formik';
import { Grid, Button } from '@inplayer-org/inplayer-ui';

// types
import { QuickAddData } from 'pages/MerchantPages/Assets/assetTypes';

// components
import Input from 'components/Fields/Input';
import FieldError from 'components/Fields/FieldError';

const { Container, Cell } = Grid;

interface FormValues {
  videoId: string;
}

const validationSchema = object().shape({
  videoId: string().required('*Required'),
});

interface OwnProps {
  onSubmit: (data: QuickAddData) => any;
  onBackButtonClick: () => void;
}

type Props = OwnProps;

const PikselQuickAdd: FunctionComponent<Props> = ({ onSubmit, onBackButtonClick }) => {
  const initialValues = {
    videoId: '',
  };

  const onFormSubmit = async (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    await onSubmit(values);
    setSubmitting(false);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={onFormSubmit}
    >
      {({ handleSubmit, isSubmitting, isValid }: FormikProps<FormValues>) => (
        <form onSubmit={handleSubmit}>
          <Container columns={3} rowGap="2rem">
            <Cell width={3}>
              <Field name="videoId" type="text" component={Input} label="Program uuid" />
              <FieldError name="videoId" />
            </Cell>
            <Cell width={1}>
              <Button fullWidth buttonModifiers={['buttonLink']} onClick={onBackButtonClick} type="button">
                Back
              </Button>
            </Cell>
            <Cell width={1} left={3}>
              <Button fullWidth type="submit" disabled={isSubmitting || !isValid} buttonModifiers={['buttonPrimary']}>
                Save
              </Button>
            </Cell>
          </Container>
        </form>
      )}
    </Formik>
  );
};

export default PikselQuickAdd;
